<template>
  <section></section>
</template>
<script>
import $ from 'jquery'
import wx from 'weixin-jsapi'

export default {
  /******************************************
    ** 组件名称
    * @description 组件描述
    * @author aihanssss
    *****************************************
    prop1          <type>            <属性描述>
    *****************************************/
  name: 'wechatShare',
  components: {},
  props: ['id', 'img', 'title'],
  data() {
    return {}
  },
  // watch: {
  //   $route(to, from) {
  //     this.init()
  //   }
  // },
  mounted() {
    this.init()
  },
  methods: {
    // 微信分享好友和朋友圈
    init() {
      // const title = '邀拍-全球专业摄影服务平台'
      // let Description =
      //   '上海邀拍数字传媒科技有限公司（原北京邀拍）成立于2015年10月，是一家聚焦互联网摄影的科技公司，致力于打造全球专业摄影服务平台。建立了服务企业级用户的「邀拍云摄影」和服务个人用户的「邀拍摄影学院」。邀拍签约了全球233个城市的超40000名摄影师，目前这些摄影师与邀拍云摄影的身影一起出现在了阿里、腾讯、百度、万科、招商银行等全球10000多家知名企业的活动现场，同时也有10000多名摄影爱好者通过邀拍摄影学院预约摄影服务并学习专业摄影知识。'
      // const title = '邀拍 | 全球专业摄影服务平台官网'
      // let Description = '互联网 + 摄影行业领导者'
      // if (sessionStorage.getItem('ShareDescription') === '' || sessionStorage.getItem('ShareDescription') === null) {
      //   Description = '点击查看现场高清大图 - Powered by 邀拍云摄影'
      // } else {
      //   Description = sessionStorage.getItem('ShareDescription')
      // }
      // console.log('Description', Description)
      // const Logo = 'https://assets.aiyaopai.com/YAOPAILOGO.jpg'
      /// //////统计代码
      var _hmt = _hmt || []
      var _this = this
      // var shareImg = this.img
      // var shareContent = this.content
      // console.log(Logo, shareImg, shareContent)
      $.ajax({
        url: 'https://livewechatauth.aiyaopai.com/auth/jsapisignature',
        type: 'Get',
        async: false,
        dataType: 'jsonp',
        jsonp: 'callback', // 值可变，名称随意，但一般设为callback就可以了
        jsonpCallback: 'gdd',
        success: function(data) {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.AppId, // 必填，公众号的唯一标识
            timestamp: data.Timestamp, // 必填，生成签名的时间戳
            nonceStr: data.NonceString, // 必填，生成签名的随机串
            signature: data.Signature.toLowerCase(), // 必填，签名，见附录1
            jsApiList: [
              'checkJsApi',
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'onMenuShareQQ',
              'onMenuShareWeibo'
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
          wx.ready(function() {
            // var IMG_SRC = this.shareDate.imgUrl
            var Logo = 'https://assets.aiyaopai.com/YAOPAILOGO.jpg'
            var shareImg = _this.img
            var shareContent = '邀片场 - 企业视频制作新工厂，全国22个运营中心，专业的服务团队，强大的制片统筹能力，量身定制行业视频解决方案。'
            var LINK = location.href.split('=')[0] + '=' + _this.id
            // let LINK = api.shareUrl + sessionStorage.getItem('LiveId')
            // 微信分享
            // document.title = title
            let TITLE = _this.title
            // console.log(_this.shareDate)
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            wx.onMenuShareTimeline({
              title: TITLE, // 分享标题
              link: LINK, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareImg, // 分享图标
              success: function() {
                // 用户确认分享后执行的回调函数
              },
              cancel: function() {
                // 用户取消分享后执行的回调函数
              }
            })

            wx.onMenuShareAppMessage({
              title: TITLE, // 分享标题
              desc: shareContent, // 分享描述
              link: LINK, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareImg, // 分享图标
              type: '', // 分享类型,music、video或link，不填默认为link
              dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function() {
                // 用户确认分享后执行的回调函数
              },
              cancel: function() {
                // 用户取消分享后执行的回调函数
              }
            })
          })
          wx.error(function(err) {
            console.log(err)
            // alert(err.errMsg)
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
